<template>
  <div class="contentbox" id="capture">
    <div class="toptitle" ref="toptitle">
      <router-link class="w" tag="p" to="/index">&lt;</router-link>
      <p v-if="azwz.status">{{azwz.name}}</p>
      <div>
        <div class="orderlisticon" @click="inorderlist">
          <img src="../assets/images/chat.png" alt="">
        </div>
        <!--<div class="personalicon" @click="toCart">-->
          <!--<img src="../assets/images/chat1.png" alt="">-->
        <!--</div>-->
        <div class="personalicon" @click="showPersonalCenter">
          <img src="../assets/images/personal.png" alt="">
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      :modal="false"
      position="right">
      <slot>
        <div class="PersonalCenter">
          <h1>個人中心</h1>
          <div>公司名稱({{$store.state.loginuserdata.enterprise}})</div>
          <div>用戶名稱({{$store.state.loginuserdata.username}})</div>
          <div>
            <mt-button @click="curtainlogout" type="danger">退出</mt-button>
          </div>
          <div>
            <mt-button @click="showPersonalCenter" type="primary">返回</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <div class="content" ref="base_img">
      <div ref="install_message" class="address">
        <div><span v-if="azd.status">{{azd.name}}</span></div>
        <div>
          <el-select v-model="batch_selection"
                     @change="on_batch_selected"
                     placeholder="Partial/Full upper/Lower">
            <el-option
              v-for="item in batch_selection_list"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="classification"
                     @change="on_classification_selected"
                     placeholder="Type">
            <el-option
              v-for="item in classification_list"
              :key="item.i_id"
              :label="item.i_name"
              :value="item.i_name">
            </el-option>
          </el-select>
        </div>
        <div class="install_box">
          {{Installationlocation}}
        </div>
      </div>
      <ul ref="install_itme_box">
        <li v-if="msg">{{msg}}</li>
        <li
          v-for="(itme,index) in list"
          :key="index"
          :class="'top'+(index+1)"
          :data-i_id="itme.i_id">
          <div class="box">
            <img @click.stop="seti_id"
                 :data-i_id="itme.i_id"
                 :data-i_name="itme.i_name"
                 :src="url +'/'+ itme.i_pic"/>
            <div @click.stop="seti_id"
                 :data-i_id="itme.i_id"
                 :class="itme.active"
                 :data-i_name="itme.i_name"
                 class="name">{{itme.i_name}}
            </div>
            <!--第二級安裝位置-->
            <div class="select_box">
              <el-select v-show="itme.show_child && itme.child.length"
                         @change="seti_id2(itme.i_id)"
                         v-model="value"
                         multiple
                         size="mini"
                         placeholder="请选择">
                <el-option
                  v-for="list in itme.child"
                  :key="list.i_id"
                  :label="list.i_name"
                  :value="list.i_id">
                </el-option>
              </el-select>
              <el-input
                v-show="itme.show_input_child"
                size="mini"
                v-model="itme.other"></el-input>
              <el-button v-show="itme.show_input_child" size="mini" @click="enter_other" type="primary">enter</el-button>
              <!--第三級安裝位置-->
              <div v-for="(list,index) in itme.child" :key="index">
                <el-select v-show="list.show_child && list.child.length"
                           @change="seti_id3(list.i_id)"
                           v-model="value2"
                           multiple
                           size="mini"
                           placeholder="请选择">
                  <el-option
                    v-for="list2 in list.child"
                    :key="list2.i_id"
                    :label="list2.i_name"
                    :value="list2.i_id">
                  </el-option>
                </el-select>
                <el-input
                  v-show="list.show_input_child"
                  size="mini"
                  v-model="list.other"></el-input>
                <el-button v-show="list.show_input_child" size="mini" @click="enter_other" type="primary">enter</el-button>
              </div>
            </div>
          </div>
        </li>
        <li class="input_box">
          <span>system:</span>
          <input type="text" v-model="system">
        </li>
      </ul>
      <div class="next_box" ref="next_box">
        <el-button @click="re_selection" type="primary">Re SELECTION</el-button>
        <el-button @click="next" type="primary">NEXT</el-button>
        <!--暫時屏蔽繪畫頁面-->
      </div>
    </div>
    <div ref="canvas_box">

    </div>
    <textarea v-show="this.editing_status === 'input_text'" ref="canvas_input" type="text"
              v-model="canvas_text"></textarea>
    <div class="btnBox" ref="btnBox">
      <mt-button type="primary" @click="painting">繪畫</mt-button>
      <mt-button v-show="this.editing_status !== 'input_text'" type="primary" @click="input_text">
        輸入文字
      </mt-button>
      <mt-button v-show="this.editing_status === 'input_text'" type="primary" @click="input_text_en">
        結束輸入文字
      </mt-button>
      <!--<mt-button size="small" type="primary" @click="commit">提交签名</mt-button>-->
      <mt-button type="primary" @click="drawing">重寫</mt-button>
      <el-button @click="next" type="primary">NEXT</el-button>
    </div>
  </div>
</template>

<script>
  import {
    productInstallationSite,
    url,
    curtainlogout, getWebsiteCompanyBottomPic,
    getClassifyInstallationSite
  } from '../assets/js/api'
  import {Popup} from 'mint-ui'
  import html2canvas from 'html2canvas'

  export default {
    name: 'index',
    data() {
      return {
        azwz:this.$store.state.page_state.home_custom.azwz,
        azd:this.$store.state.page_state.home_custom.azd,
        msg: '',
        list: [],
        Installationlocation: '',
        addname: '',
        popupVisible: false,
        value: '',
        value2: '',
        url: url,
        show_child: false,
        // LocalShoppingCartlength:0
        canvas_dom: '',
        editing_status: 'painting',
        points: [],
        canvasTxt: null,
        startX: 0,
        startY: 0,
        moveY: 0,
        moveX: 0,
        endY: 0,
        endX: 0,
        isDown: false,
        Style_pictures: '',
        canvas_text: '',
        canvas_text_left: 0,
        canvas_text_top: 0,
        inputX: 0,
        inputY: 0,
        drawing_state: false,
        batch_selection: '',
        batch_selection_list:['Full upper & lower','Full upper','Full lower','reset'],
        classification_list:[],
        classification:'',
        system:'',
      }
    },
    components: {
      Popup,
    },
    mounted() {
      this.ongetproductInstallationSite()
      getWebsiteCompanyBottomPic().then(data => {
        if (data.status) {
          this.$refs.base_img.style.background = 'url(' + data.data.bottom_pic + ') no-repeat center center'
          this.$refs.base_img.style.backgroundSize = '100%'
        }
      })
      // this.LocalShoppingCartlength = sessionStorage.getItem('LocalShoppingCart')?JSON.parse(sessionStorage.getItem('LocalShoppingCart')).length : 0
    },
    methods: {
      on_batch_selected(){
        let f = this.list.length/2
        this.list.map((itme) => {
          itme.active = ''
        })
        if (this.batch_selection === 'Full upper & lower'){
          this.list.map((itme) => {
            itme.active = 'active'
          })
        }
        else if (this.batch_selection === 'Full upper'){
          this.list.map((itme,index) => {
            if (index+1 <= f){
              itme.active = 'active'
            }
          })
        }
        else if (this.batch_selection === 'Full lower'){
          this.list.map((itme,index) => {
            if (index+1 > f){
              itme.active = 'active'
            }
          })
        }
        this.statistics_installation()
      },
      on_classification_selected(){
        // classification
        this.list.map(itme=>{
          if (itme.child && itme.active){
            itme.child.map(list=>{
              list.active = ''
              if (list.i_name === this.classification){
                list.active = true
              }
            })
          }
        })
        this.statistics_installation()
      },
      drawing() {
        // document.querySelector("#capture")
        this.$refs.base_img.style.display = 'block'
        this.$refs.base_img.style.paddingTop = '250px'
        this.$refs.base_img.style.margin = '0'
        this.$refs.canvas_box.innerHTML = ''
        this.$refs.install_message.style.display = 'none'
        this.$refs.next_box.style.display = 'none'
        this.$refs.toptitle.style.display = 'none'
        this.$refs.btnBox.style.display = 'none'
        this.$refs.install_itme_box.style.paddingTop = '120'
        this.$refs.install_itme_box.style.marginTop = '100px'
        html2canvas(document.querySelector("#capture")).then(canvas => {
          // canvas.className = 'canvas_drawing'
          this.canvasTxt = canvas.getContext('2d')
          this.canvas_dom = canvas
          // canvas.height = 300
          // canvas.width = 500
          canvas.ontouchstart = this.touchStart
          canvas.ontouchmove = this.touchMove
          canvas.ontouchend = this.touchEnd

          canvas.onmousedown = this.mouseDown
          canvas.onmousemove = this.mouseMove
          canvas.onmouseup = this.mouseUp

          canvas.onclick = this.click_canvas
          this.$refs.canvas_box.appendChild(canvas)
          this.$refs.base_img.style.display = 'none'
          this.$refs.toptitle.style.display = 'flex'
          this.$refs.btnBox.style.display = 'flex'
        });
      },
      seti_id(e) {
        let id = e.target.getAttribute('data-i_id')
        this.$store.commit('seti_id', id)
        this.value = ''
        this.value2 = ''
        this.list.map((itme) => {
          itme.show_child = false
          itme.show_input_child = false
          if (itme.child) {
            itme.child.map(list => {
              list.show_child = false
              list.show_input_child = false
            })
          }
          if (itme.i_id === id) {
            if (itme.active) {
              itme.active = ''
              this.value = ''
              if (itme.child) {
                itme.child.map(list => {
                  list.active = ''
                  list.show_child = false
                  list.show_input_child = false
                  this.value2 = ''
                  if (list.child) {
                    list.child.map(list2 => {
                      list2.active = ''
                    })
                  }
                })
              }
            }
            else {
              itme.active = 'active'
              itme.show_child = true
            }
          }
        })
        this.statistics_installation()
      },
      seti_id2(p_id) {
        this.list.map((itme) => {
          if (itme.child.length) {
            itme.child.map(list => {
              if (list.i_pid === p_id){
                list.active = ''
              }
              list.show_child = false
              list.show_input_child = false
              if (this.value.indexOf(list.i_id) !== -1) {
                if (list.i_name === 'Other' || list.i_name === 'other'){
                  itme.show_child = false
                  itme.show_input_child = true
                  // if (list.child.length){
                  //   list.child.map(list2=>{
                  //     list2.active = ''
                  //   })
                  // }
                }
                else {
                  list.active = 'active'
                  if (list.i_id === this.value[this.value.length-1]){
                    list.show_child = true
                  }
                }
              }
            })
          }
        })
        this.statistics_installation()
      },
      seti_id3(p_id){
        this.list.map((itme) => {
          if (itme.child.length) {
            itme.child.map(list => {
              if (list.child.length){
                list.child.map(list2=>{
                  if (list2.i_pid === p_id){
                    list2.active = ''
                  }
                  if (this.value2.indexOf(list2.i_id) !== -1) {
                    if (list2.i_name === 'Other' || list2.i_name === 'other'){
                      list.show_child = false
                      list.show_input_child = true
                    }
                    else {
                      list2.active = 'active'
                      list2.show_child = true
                    }
                  }
                })
              }
            })
          }
        })
        this.statistics_installation()
      },
      enter_other(){
        this.list.map((itme) => {
          itme.show_input_child = false
        })
        this.statistics_installation()
      },
      //統計安裝位置
      statistics_installation() {
        this.Installationlocation = ''
        if (this.batch_selection && this.batch_selection !== 'reset'){
          this.Installationlocation = this.batch_selection + ' ' + this.classification
        }
        else {
          this.list.map((itme) => {
            if (itme.active) {
              if (itme.child.length) {
                this.Installationlocation += itme.i_name + ' '
              }
              if (itme.other){
                this.Installationlocation += itme.other + ' '
              }
              if (itme.child.length) {
                itme.child.map(list => {
                  if (list.active) {
                    this.Installationlocation += list.i_name + ' '
                    if (list.child.length){
                      list.child.map(list2=>{
                        if (list2.active) {
                          this.Installationlocation += list2.i_name + ' '
                        }
                      })
                    }
                  }
                })
              }
              this.Installationlocation +=  ', '
            }
          })
        }

      },
      re_selection() {
        this.Installationlocation = ''
      },
      next() {
        localStorage.setItem('Installationlocation', this.Installationlocation)
        // this.$store.commit('set_install_canvas',this.canvas_dom.toDataURL("image/png")) //安裝位置繪圖
        this.$store.commit('set_system',this.system) //安裝位置備註
        this.$router.push({ path: '/shop?id='+this.$route.query.id+'&product_id='+this.$route.query.product_id+'&classify_id='+this.$route.query.classify_id});
        // this.$router.push({path: '/commodity'});
      },
      ongetproductInstallationSite() {
        getClassifyInstallationSite(this.$route.query.classify_id).then((data) => {
          if (data.status) {
            if (data.data.length === 0){
              if (this.$route.query.return){
                this.$router.push({ path: '/'});
              }
              else {
                this.$router.push({ path: '/shop?id='+this.$route.query.id+'&product_id='+this.$route.query.product_id+'&classify_id='+this.$route.query.classify_id});
              }
            }
            data.data.map(itme => {
              itme.child = []
              if (itme.i_pid === '0') {
                itme.show_input_child = false
                itme.other = ''
                this.list.push(itme)
              }
            })
            // 整理二級安裝位置
            data.data.map(itme => {
              this.list.map(list => {
                if (itme.i_pid !== '0' && itme.i_pid === list.i_id) {
                  itme.active = ''
                  itme.show_child = false
                  itme.show_input_child = false
                  itme.other = ''
                  list.child.push(itme)
                }
              })
            })
            // 整理三級安裝位置
            data.data.map(itme => {
              this.list.map(list => {
                list.child.map(list2=>{
                  if (itme.i_pid !== '0' && itme.i_pid === list2.i_id) {
                    itme.active = ''
                    list2.child.push(itme)
                  }
                })

              })
            })

            // 第一層的排序
            this.list.sort((a, b) => {
              return a.i_sort - b.i_sort
            })
            // 第二層的排序
            this.list.map(itme=>{
              if (itme.child){
                itme.child.sort((a, b) => {
                  return a.i_sort - b.i_sort
                })
                // 第三層的排序
                itme.child.map(list=>{
                  list.child.sort((a, b) => {
                    return a.i_sort - b.i_sort
                  })
                })
              }
            })
            // 歸類
            let has = false
            this.list.map(itme=>{
              if (itme.child){
                itme.child.map(list=>{
                  this.classification_list.map(list2=>{
                    if (list2.i_name === list.i_name){
                      has = true
                    }
                  })
                  if (!has){
                    this.classification_list.push(list)
                  }
                })
              }
            })
          }
        })
      },
      showPersonalCenter() {
        this.popupVisible ? this.popupVisible = false : this.popupVisible = true
      },
      curtainlogout() {
        curtainlogout().then(data => {
          sessionStorage.removeItem('LocalShoppingCart');
          sessionStorage.removeItem('order_id');
          localStorage.removeItem('logindata');
          localStorage.removeItem('userdata');
          this.$store.commit('res_state')
          this.$router.push({path: '/'});
        })
      },
      inorderlist() {
        this.$store.commit('set_inorderilstroutername', 'index')
        this.$router.push({path: '/orderlist'});
      },
      // 跳转到购物车
      toCart() {
        this.$router.push({path: '/shoppingcart'});
      },

      //电脑设备事件
      mouseDown(ev) {
        if (this.editing_status !== 'painting') {
          return
        }

        ev = ev || event
        ev.preventDefault()
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.isDown = true
          this.imgUrl =
            (this.canvas_dom && this.canvas_dom.toDataURL()) || ''
        }
      },
      mouseMove(ev) {
        if (this.editing_status !== 'painting') {
          return
        }
        ev = ev || event
        ev.preventDefault()
        if (this.isDown) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      mouseUp(ev) {
        if (this.editing_status !== 'painting') {
          return
        }
        ev = ev || event
        ev.preventDefault()
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.points.push({x: -1, y: -1})
          this.isDown = false
        }
      },
      //移动设备事件
      touchStart(ev) {
        if (this.editing_status !== 'painting') {
          return
        }
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      touchMove(ev) {
        if (this.editing_status !== 'painting') {
          return
        }
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      touchEnd(ev) {
        if (this.editing_status !== 'painting') {
          return
        }
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth = "2";
          this.canvasTxt.strokeStyle = "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.points.push({x: -1, y: -1})
          this.imgUrl =
            (this.canvas_dom && this.canvas_dom.toDataURL()) || ''
        }
      },
      //重写
      overwrite() {
        if (this.$store.state.client) {
          MessageBox({
            title: '提示',
            message: '重写将会清除您之前的操作，您确定重写么?',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true
          }).then((v) => {
            if (v === 'confirm') {
              this.canvasTxt.clearRect(
                0,
                0,
                this.canvas_dom.width,
                this.canvas_dom.height
              )
              this.points = []
              this.canvasTxt.drawImage(this.Style_pictures, 0, 0)
            }
            else {
            }
          });
        }
        else {
          this.$confirm('重写将会清除您之前的操作，您确定重写么?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            this.canvasTxt.clearRect(
              0,
              0,
              this.canvas_dom.width,
              this.canvas_dom.height
            )
            this.points = []
            this.canvasTxt.drawImage(this.Style_pictures, 0, 0)
          }).catch((c) => {
          });
        }
      },
      click_canvas(e) {
        if (this.editing_status === 'input_text') {
          this.inputX = e.offsetX
          this.inputY = e.offsetY - 8
          this.$refs.canvas_input.style.left = this.inputX + 'px'
          this.$refs.canvas_input.style.top = this.inputY + 'px'
          this.$refs.canvas_input.focus()
        }
      },
      input_text() {
        this.canvas_dom.style.cursor = 'text';
        this.editing_status = 'input_text'
      },
      input_text_en() {
        this.canvas_dom.style.cursor = 'auto';
        this.editing_status = ''
        this.text_in_canvas()
      },
      text_in_canvas() {
        this.canvasTxt.font = "16px 黑体";
        // 设置颜色
        this.canvasTxt.fillStyle = "#000";
        // 设置水平对齐方式
        this.canvasTxt.textAlign = "center";
        // 设置垂直对齐方式
        this.canvasTxt.textBaseline = "middle";
        // 绘制文字（参数：要写的字，x坐标，y坐标）
        this.canvasTxt.fillText(this.canvas_text, this.inputX + 15, this.inputY + 8);
        this.canvas_text = ''
      },
      painting() {
        // this.canvas_dom.style.cursor = 'auto';
        console.log(this.canvas_dom)
        this.editing_status = 'painting'
      },
      //提交签名
      commit() {
        console.log(this.canvas_dom.toDataURL())
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../assets/less/base";

  .contentbox {
    text-align: center;
    width: 100%;
    .toptitle {
      position: fixed;
      z-index: 1;
      width: 100%;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        height: 46px;
      }
      .personalicon {
        /*width: 12%;*/
        cursor: pointer;
        img {
          height: 32px;
        }
      }
      .orderlisticon {
        /*width: 12%;*/
        cursor: pointer;
      }
      .w {
        font-size: 40px;
        cursor: pointer;
      }
      > p, > img, > div {
        width: 30%;
      }
      @media (min-width: @screen-xs-max) {
        > img {
          width: auto;
        }
      }
      > div {
        position: relative;
        /*text-align: right;*/
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          /*align-self:flex-end;*/
          position: absolute;
          top: 7%;
          right: 13%;
          color: #fff;
          background-color: red;
          /*height: 20px;*/
          line-height: 20px;
          padding: 1px 2px;
          border-radius: 20px;
        }
      }
    }
    .PersonalCenter {
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      h1 {
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div {
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .content {
      /*width: 312px;*/
      width: 100%;
      height: calc(100vh - 52px);
      margin: 52px auto 0 auto;
      position: relative;
      overflow-x: hidden;
      .address {
        height: 40px;
        line-height: 40px;
        font-size: 0.5rem;
        text-align: left;
        padding-left: 20px;
        color: #000;
        padding-top: 10px;
        .install_box{
          min-height: 42px;
          margin-top: 10px;
          width: 192px;
          padding: 10px;
          border: 1px solid #DCDFE6;
        }
      }
      ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 250px;
        position: absolute;
        /*left: 10%;*/
        @media (min-width: 1200px) {
          width: 70%;
          left: 15%;
        }
        @media (min-width: 850px) and (max-width: 1200px) {
          width: 90%;
          left: 5%;
        }
        @media (min-width: 750px) and (max-width: 850px) {
          width: 100%;
        }
        @media (min-width: 500px) and (max-width: 750px) {
          width: 150%;
          left: -25%;
        }
        @media (max-width: 500px) {
          width: 200%;
          left: -50%;
        }
        li {
          /*height: 96vw;*/
          position: absolute;
          cursor: pointer;
          width: 50px;
          height: 50px;
          margin-left: 15%;
          &.input_box {
            top: 0;
            left: 20%;
            display: flex;
            align-items: center;
            font-size: 0.5rem;
            input {
              border-bottom: 1px solid #000;
              outline: none;
              background: transparent;
              width: 130px;
            }
          }
          &.top0 {
            left: 0
          }
          &.top1 {
            top: -50px;
            left: 14%
          }
          &.top2 {
            top: -100px;
            left: 14%
          }
          &.top3 {
            top: -146px;
            left: 15%
          }
          &.top4 {
            top: -184px;
            left: 16%
          }
          &.top5 {
            top: -218px;
            left: 18%
          }
          &.top6 {
            top: -250px;
            left: 20%
          }
          &.top7 {
            top: -277px;
            left: 23%
          }
          &.top8 {
            top: -280px;
            left: 28%
          }

          &.top9 {
            top: -280px;
            left: 33%
          }
          &.top10 {
            top: -277px;
            left: 38%
          }
          &.top11 {
            top: -250px;
            left: 42%
          }
          &.top12 {
            top: -218px;
            left: 44%
          }
          &.top13 {
            top: -184px;
            left: 45%
          }
          &.top14 {
            top: -146px;
            left: 46%
          }
          &.top15 {
            top: -100px;
            left: 46%
          }
          &.top16 {
            top: -50px;
            left: 46%
          }

          &.top17 {
            top: 50px;
            left: 46%
          }
          &.top18 {
            top: 100px;
            left: 46%
          }
          &.top19 {
            top: 146px;
            left: 46%
          }
          &.top20 {
            top: 184px;
            left: 45%
          }
          &.top21 {
            top: 218px;
            left: 44%
          }
          &.top22 {
            top: 250px;
            left: 42%
          }
          &.top23 {
            top: 277px;
            left: 38%
          }
          &.top24 {
            top: 280px;
            left: 33%
          }
          &.top25 {
            top: 280px;
            left: 28%
          }
          &.top26 {
            top: 277px;
            left: 23%
          }
          &.top27 {
            top: 250px;
            left: 20%
          }
          &.top28 {
            top: 218px;
            left: 18%
          }
          &.top29 {
            top: 184px;
            left: 16%
          }
          &.top30 {
            top: 146px;
            left: 15%
          }
          &.top31 {
            top: 100px;
            left: 14%
          }
          &.top32 {
            top: 50px;
            left: 14%
          }
          .box {
            position: relative;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            .name {
              position: absolute;
              top: 15px;
              left: 20px;
              color: red;
              font-weight: bold;
              font-size: 18px;
              &.active {
                color: #3a8ee6;
              }
            }
            .select_box {
              width: 400px;
              position: absolute;
              z-index: 9;
              top: 8px;
              left: 50px;
              display: flex;
              .el-input{
                width: 50%;
              }
            }
          }
        }
      }
      .next_box {
        text-align: right;
        position: fixed;
        bottom: 20px;
        right: 20px;
        > div {
          cursor: pointer;
        }
      }
    }
    textarea {
      position: absolute;
      background: transparent;
      /*border-bottom: 1px;*/
    }
    .btnBox {
      position: fixed;
      bottom: 20px;
      right: 20px;
      display: none;
      > button {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commodity.vue